import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import './apply-now.component.scss';
import * as _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap-datepicker';
var ApplyNow = /** @class */ (function (_super) {
    tslib_1.__extends(ApplyNow, _super);
    function ApplyNow(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    ApplyNow.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.modals = Array.from(this.element.querySelectorAll('.js-apply-now-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-apply-now-modal-open'));
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.pagerHomeButtonContainer = this.element.querySelector('.js-pager-home-button-container');
        this.pagerHomeButton = this.element.querySelector('.js-pager-back-button');
        this.pagerHomePage = this.element.querySelector('.js-pager-page-home');
        this.pagerPages = Array.from(this.element.querySelectorAll('.js-pager-page'));
        this.pagePageToggles = Array.from(this.element.querySelectorAll('.js-pager-page-toggle'));
        this.applyForm = this.element.querySelector('form');
        this.applyFormSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
        this.applyFormRadio = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));
        this.publicHolidays = ['2018/01/01', '2018/03/21', '2018/03/30', '2018/04/02', '2018/04/27', '2018/05/01', '2018/06/16', '2018/08/09', '2018/09/24', '2018/12/16', '2018/12/17', '2018/12/25', '2018/12/26'];
        // nps customer survey
        this.npsCustomerSurveyButton = document.querySelector('#nps-customer-survey_button');
        this.npsCustomerSurvey = document.querySelector('#form-container-modal-nps-customer-survey');
        // DATE PICKER
        $(document).ready(function () {
            $('input.js-date-picker').datepicker({
                todayHighlight: true,
                format: 'yyyy/mm/dd',
                daysOfWeekDisabled: [0, 6],
                enableOnReadonly: true,
                autoclose: true
            }).on('changeDate', function (event) {
                var _event;
                if (typeof window.event === 'function') {
                    _event = new Event('change');
                    this.dispatchEvent(_event);
                }
                else {
                    _event = document.createEvent('HTMLEvents');
                    _event.initEvent('change', false, false);
                    this.dispatchEvent(_event);
                }
            });
        });
        TooltipsService.initTooltips();
        this.surveyInfoService.checkEnableSurvey();
    };
    ApplyNow.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        // this.modalLinks.map((item) => item.addEventListener('click', (event) => {
        // 	this.openModals(event);
        // }));
        // Changed the way this works for dynamic content - Malcolm 14-02-2018
        document.addEventListener('click', function (e) {
            var composedPath = function (el) {
                var path = [];
                while (el) {
                    path.push(el);
                    if (el.tagName === 'HTML') {
                        path.push(document);
                        path.push(window);
                        return path;
                    }
                    el = el.parentElement;
                }
            };
            var path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
            var hasClass = function (cls) {
                return _.filter(path, function (p) {
                    var exists = false;
                    _.each(p.classList, function (cl) {
                        if (cl === cls) {
                            exists = true;
                        }
                    });
                    if (p.classList && exists) {
                        return p;
                    }
                })[0];
            };
            if (hasClass('js-apply-now-modal-open')) {
                _this.openModals(e);
            }
        }, false);
        this.pagePageToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.togglePages(event);
        }); });
        if (this.pagerHomeButton) {
            this.pagerHomeButton.addEventListener('click', function () { return _this.showHomePage(); });
        }
        this.applyFormRadio.map(function (item) { return item.addEventListener('click', function (event) {
            var evt = event.target;
            var identificationField = _this.applyForm.querySelector('input[name=identification]');
            var identificationType = evt.value;
            if (identificationType === 'said') {
                identificationField.classList.remove('form__input--identification--passport');
                identificationField.classList.add('form__input--identification');
                identificationField.placeholder = 'Enter you South Africa ID number';
                identificationField.type = 'number';
            }
            else {
                identificationField.classList.remove('form__input--identification');
                identificationField.classList.add('form__input--identification--passport');
                identificationField.placeholder = 'Enter you Passport number';
                identificationField.type = 'text';
            }
        }); });
        this.applyFormSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.formsService.detect(_this.applyForm, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'));
            }
        }); });
    };
    ApplyNow.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    ApplyNow.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-apply-now-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    ApplyNow.prototype.closeModal = function () {
        var _this = this;
        this.analyticsService.dtmFormAbandon();
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
            if (_this.npsCustomerSurveyButton && _this.npsCustomerSurvey) {
                _this.surveyInfoService.checkEnableSurvey();
                if (_this.surveyInfoService.getSurveyCompleteValue() === "false"
                    && (_this.surveyInfoService.getSurveyTimeExpireValue() === ""
                        || _this.surveyInfoService.getSurveyTimeExpireValue() == null)) {
                    if (_this.activeModal != _this.getModalById('form-container-modal-nps-customer-survey')) {
                        _this.npsCustomerSurveyButton.click();
                    }
                    else {
                        // Add expiry time
                        localStorage.setItem(_this.surveyInfoService.getSurveyCompleteName(), "true");
                        _this.surveyInfoService.setTimeExpired();
                    }
                }
            }
        }, 250);
    };
    ApplyNow.prototype.openModal = function () {
        var _this = this;
        this.formDatePicker = this.activeModal.querySelector('.js-date-picker');
        this.formTimePicker = this.activeModal.querySelector('.js-time-picker');
        if (this.formDatePicker) {
            this.formDatePicker.addEventListener('change', function (event) {
                _this.validateDate(event.target);
            });
        }
        this.resetForm();
        this.populateDatePicker();
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
    };
    ApplyNow.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    ApplyNow.prototype.togglePages = function (event) {
        this.pagerHomePage.classList.add('apply-now__page--hidden');
        this.pagerHomeButtonContainer.classList.add('apply-now__home-button-container--visible');
        this.hidePages();
        var goToPage = event.currentTarget.getAttribute('data-target');
        this.element.querySelector("#" + goToPage).classList.remove('apply-now__page--hidden');
    };
    ApplyNow.prototype.hidePages = function () {
        for (var i = 0; i < this.pagerPages.length; i++) {
            this.pagerPages[i].classList.add('apply-now__page--hidden');
        }
    };
    ApplyNow.prototype.showHomePage = function () {
        this.hidePages();
        this.pagerHomePage.classList.remove('apply-now__page--hidden');
        this.pagerHomeButtonContainer.classList.remove('apply-now__home-button-container--visible');
    };
    ApplyNow.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    ApplyNow.prototype.populateDatePicker = function () {
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            $(this.formDatePicker).datepicker('setStartDate', this._startDate).datepicker('setDatesDisabled', this.publicHolidays);
        }
    };
    ApplyNow.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ''; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate !== '') {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate !== _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if ((_currentMin >= 30) && (_currentHour <= 15)) {
            _currentHour++;
        }
        else if ((_currentMin >= 30) && (_currentHour >= 15)) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate === holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay === 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay === 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var item = this.formTimePicker;
        var _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
        for (var i = item.options.length - 1; i >= 0; i--) {
            if (item.options[i].value !== 'Anytime') {
                if ((item.options[i].value < _tmpTime) && (_enabledOptions === false)) {
                    item.options[i].disabled = true;
                }
                else if (_enabledOptions === true) {
                    item.options[i].disabled = false;
                }
            }
        }
        return _currentDateTime;
    };
    return ApplyNow;
}(Base));
export { ApplyNow };



//////////////////
// WEBPACK FOOTER
// ./components/apply-now/apply-now.component.ts
// module id = 89
// module chunks = 0